query AppliedEntityDocuments(
  $id: UUID!
  $orderBy: [AppliedEntityDocumentsOrderBy!]
) {
  appliedEntityDocuments(
    orderBy: $orderBy
    filter: { _documentFileId: { equalTo: $id } }
  ) {
    nodes {
      _documentFileId
      id
      transactionType
      accountingStampTransactionReference
      _createdDate
      accountingStampDate
      vendorReference
      description
      invoiceNumber
      invoiceDate
      controlTotalAmount
      openingBalance
      appliedAmount
      _poolAllocationTotal
      retiredAmount
      overageAmount
      remainingBalance
      entityId
    }
    aggregates {
      sum {
        controlTotalAmount
        appliedAmount
        openingBalance
        retiredAmount
        overageAmount
        remainingBalance
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
